import React, { useEffect, useState, useCallback } from 'react';
import { Edit, Delete, Add, ArrowBack, Search } from "@mui/icons-material";
import api from '../../services/api';
import styles from '../../assets/styles/LayoutShared.module.css';
import AreaForm from './AreaForm';

const TIPO_LABEL: Record<string, string> = {
  municipio: 'Município',
  represa: 'Represa',
  bacia: 'Bacia',
  apa: 'APA',
  outro: 'Outro',
};

const AreasList = () => {
  const [areas, setAreas] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [formOpen, setFormOpen] = useState(false);
  const [areaEditando, setAreaEditando] = useState<any>(null);

  const fetchAreas = useCallback((searchTerm: string) => {
    api.get(`/pesca/areas?search=${searchTerm}`).then(res => {
      setAreas(res.data.data);
    });
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => setSearch(tempSearch), 500);
    return () => clearTimeout(handler);
  }, [tempSearch]);

  useEffect(() => {
    fetchAreas(search);
  }, [search, fetchAreas]);

  const handleNovo = () => {
    setAreaEditando(null);
    setFormOpen(true);
  };

  const handleEditar = (area: any) => {
    setAreaEditando(area);
    setFormOpen(true);
  };

  const handleExcluir = async (area: any) => {
    if (!window.confirm(`Remover a área de pesca "${area.nome}"?`)) return;
    await api.delete(`/pesca/areas/${area.uid_pesca_area}`);
    fetchAreas(search);
  };

  const handleSalvo = () => {
    setFormOpen(false);
    fetchAreas(search);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerTitle}>
        <h1 className={styles.greenTitle}>Áreas de Pesca</h1>

        <div style={{ position: 'relative', flex: 1, maxWidth: '400px', margin: '0 20px' }}>
          <Search style={{ position: 'absolute', left: '10px', top: '10px', color: '#888' }} />
          <input
            type="text"
            placeholder="Pesquisar área..."
            value={tempSearch}
            onChange={(e) => setTempSearch(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 10px 10px 40px',
              borderRadius: '20px',
              border: '1px solid #ddd',
              outline: 'none'
            }}
          />
        </div>

        <div className={styles.actionsHeader}>
          <p style={{ alignSelf: 'center', fontSize: '0.9rem', color: '#666', marginRight: '10px' }}>
            Qtd: <span style={{ fontWeight: 'bold', color: 'var(--green-700)' }}>{areas.length}</span>
          </p>

          <button className={styles.blueBtn} onClick={handleNovo} title="Adicionar Nova">
            <Add />
          </button>
          <button className={styles.blueBtn} onClick={() => window.history.back()} title="Voltar">
            <ArrowBack />
          </button>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Tipo</th>
              <th>Município/UF</th>
              <th>Projeto(s)</th>
              <th style={{ textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {areas.map((a) => (
              <tr key={a.uid_pesca_area}>
                <td>{a.nome}</td>
                <td>{TIPO_LABEL[a.tipo] || a.tipo}</td>
                <td>{a.municipio ? `${a.municipio}${a.uf ? ' / ' + a.uf : ''}` : '-'}</td>
                <td>
                  {a.projetoVinculos && a.projetoVinculos.length > 0
                    ? a.projetoVinculos.map((v: any) => v.projeto?.nome).filter(Boolean).join(', ')
                    : <span style={{ color: '#999' }}>Nenhum</span>}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    <Edit fontSize="small" style={{ color: '#03c9fe', cursor: 'pointer' }} onClick={() => handleEditar(a)} />
                    <Delete fontSize="small" style={{ color: '#f75a68', cursor: 'pointer' }} onClick={() => handleExcluir(a)} />
                  </div>
                </td>
              </tr>
            ))}
            {areas.length === 0 && (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                  Nenhuma área de pesca cadastrada.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {formOpen && (
        <AreaForm
          area={areaEditando}
          onClose={() => setFormOpen(false)}
          onSaved={handleSalvo}
        />
      )}
    </div>
  );
};

export default AreasList;
